import React, { useState, useEffect } from 'react';
import axios from '@/utils/api';
import { X, Brain } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Use same-origin API path on production custom domains
const API_BASE = window.location.hostname.includes('preview.emergentagent.com') || window.location.hostname === 'localhost'
  ? (process.env.REACT_APP_BACKEND_URL || '')
  : '';

const AIUsersModal = ({ onClose, onUserClick }) => {
  const [aiUsers, setAIUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAIUsers = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/admin/ai-users`);
        setAIUsers(res.data);
      } catch (err) {
        console.error('Failed to fetch AI users:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchAIUsers();
  }, []);

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center p-4" style={{ zIndex: 9999 }} onClick={onClose}>
      <div 
        className="bg-gradient-to-br from-[#2D063E] to-[#1a0527] border border-[#4A0A66] rounded-xl p-6 max-w-lg w-full max-h-[80vh] overflow-y-auto"
        onClick={e => e.stopPropagation()}
        data-testid="ai-users-modal"
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-white flex items-center gap-2">
            <Brain className="w-5 h-5 text-purple-400" />
            AI Journal Coach Users
          </h2>
          <Button variant="ghost" size="sm" onClick={onClose} className="text-[#FDF2F8]/60 hover:text-white">
            <X className="w-5 h-5" />
          </Button>
        </div>

        {loading ? (
          <div className="flex justify-center py-8">
            <div className="animate-spin w-8 h-8 border-2 border-purple-400 border-t-transparent rounded-full" />
          </div>
        ) : aiUsers.length === 0 ? (
          <p className="text-[#FDF2F8]/60 text-center py-8">No users have used AI Coach yet</p>
        ) : (
          <div className="space-y-3">
            {aiUsers.map((user, idx) => (
              <div 
                key={user.user_id || idx} 
                className={`flex items-center justify-between bg-[#4A0A66]/30 rounded-lg p-3 ${onUserClick ? 'cursor-pointer hover:bg-[#4A0A66]/50 transition-colors' : ''}`}
                onClick={(e) => {
                  if (onUserClick) {
                    e.stopPropagation();
                    onUserClick(user);
                  }
                }}
                data-testid={`ai-user-row-${user.user_id || idx}`}
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-violet-600 flex items-center justify-center text-white font-bold">
                    {(user.name || user.email || 'U')[0].toUpperCase()}
                  </div>
                  <div>
                    <p className="text-white font-medium">{user.name || 'Anonymous'}</p>
                    <p className="text-xs text-[#FDF2F8]/60">{user.email}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-lg font-bold text-purple-400">{user.reflection_count || 1}</p>
                  <p className="text-xs text-[#FDF2F8]/50">reflections</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AIUsersModal;
